module.exports = __webpack_public_path__ + "static/media/book-spells.401f878d.svg";